import * as React from "react";
function SvgOriflamme(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M38.3 45.2V0h-2.8v2.8h-30l5.6 11.3-5.6 11.3h30v19.8h-4.2V48h11.3v-2.8h-4.3zM10.1 22.6l3.6-6.9.6-1.2-.6-1.5-3.6-7.4h25.4v16.9H10.1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgOriflamme);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
